import React from 'react';

import analytics from '@repo/analytics';
import { themeStyle } from '@repo/ui/theming';
import IconChevronDown from '@repo/ui-icons/IconChevronDown';
import { H4 } from '@repo/ui-kit/components/core/Typography';

import { LANDING_PAGES_TOGGLE_CLICK } from 'global/analyticsEvents';
import { FlexColumn, FlexRow } from 'styles/layouts';

import TextBlock from '../shared/TextBlock/TextBlock';

import { ChevronWrapper, ItemWrapper, Text, TextWrapper } from './styles';
import { FrequentlyAskedQuestionItemProps } from './types';

export const FrequentlyAskedQuestionItem: React.FC<
  FrequentlyAskedQuestionItemProps
> = ({ title, text, isOpen, onOpen }) => {
  const handleCollapseClick = () => {
    if (isOpen) {
      analytics.track(LANDING_PAGES_TOGGLE_CLICK, {
        component: 'frequentlyAskedQuestion',
        title: title.slice(0, 25),
      });
    }
    onOpen();
  };

  return (
    <ItemWrapper isOpen={isOpen}>
      <FlexColumn padding="16px" onClick={handleCollapseClick}>
        <FlexRow justifyContent="space-between">
          <H4 as="h3">{title}</H4>
          <ChevronWrapper isOpen={isOpen}>
            <IconChevronDown color={themeStyle.varInkMedium} size={20} />
          </ChevronWrapper>
        </FlexRow>
        <TextWrapper isOpen={isOpen}>
          <Text>
            <FlexColumn marginTop="24px">
              <TextBlock
                color={themeStyle.varInkMain}
                paragraphType="p2"
                text={text}
              />
            </FlexColumn>
          </Text>
        </TextWrapper>
      </FlexColumn>
    </ItemWrapper>
  );
};
